import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
// Lodash
import _reduce from 'lodash/reduce';
var addLeafColumns = function addLeafColumns(leafColumns, column) {
  var children = column.getChildren();
  if (!(children !== null && children !== void 0 && children.length)) {
    leafColumns.push(column);
    return leafColumns;
  }
  var childColumns = getLeafColumns(children);
  leafColumns.push.apply(leafColumns, _toConsumableArray(childColumns));
  return leafColumns;
};
export var getLeafColumns = function getLeafColumns(columns) {
  return _reduce(columns, addLeafColumns, []);
};